import {useEffect} from 'preact/hooks';
import {useRouteError} from 'react-router-dom';
import appLogger from '@core/LoggingProvider';

const refreshPage = () => window.location.reload();

const RegistrationErrorPage = ( {onRefresh = refreshPage} ) => {
    const error = useRouteError();

    useEffect( () => {
        if ( error ) {
            appLogger.capture( error );
        }
    }, [error] );

    return (
        <div className="w-full md:max-w-sm mx-auto my-8 md:my-16 text-center">
            <img className="block my-4 md:my-12 mx-auto h-auto w-24 md:w-32"
                 src="/svg/site-logos/upi-icon-color-tagline.svg"
                 alt="Ultradent Products Logo"/>
            <h1 className="text-xl font-normal leading-tight">
                Registration is temporarily unavailable
            </h1>
            <p className="mt-4">
                Sorry, we couldn't load registration. Please refresh the page to try again.
            </p>
            <button className="button secondary mt-8" type="button" onClick={onRefresh}>
                Refresh page
            </button>
            <p className="mt-8 text-grey-dark">
                If the problem continues, contact Customer Service for help.
            </p>
        </div>
    );
};

export default RegistrationErrorPage;
